import request from '@/utils/request'
/**
 * 公司流程列表
 * @param  data {
 * pageNum	页码
 * pageSize	每页条数
 * companyName	公司名称
 * processName	流程名称
 * technicalArea	技术领域
 * status	流程状态
 * startTime	更新起始时间
 * endTime	更新截止时间
 *               }
 */
export function companyFlowProcess(data) {
  return request({
    url: '/companyFlow/process/select',
    method: 'post',
    data: {
      ...data
    }
  })
}

/**
 * 项目流程列表
 * @param  data {
 * pageNum	页码
 * pageSize	每页条数
 * companyName	公司名称
 * processName	流程名称
 * technicalArea	技术领域
 * status	流程状态
 * startTime	更新起始时间
 * endTime	更新截止时间
 *               }
 */
export function projectFlowProcess(data) {
  return request({
    url: '/projectFlow/process/select',
    method: 'post',
    data: {
      ...data
    }
  })
}
/**
 * 公司流程详细
 * @param {流程id} id
 */
export function getCompanyFlowDetail(id) {
  return request({
    url: '/company/process/details',
    method: 'post',
    data: {
      id: id
    }
  })
}

/**
 * 项目流程详细
 * @param {流程id} id
 */
export function getProjectFlowDetail(id) {
  return request({
    url: '/project/process/latest',
    method: 'post',
    data: {
      projectId: id
    }
  })
}

/**
 * 根据项目查询当前最新的已通过流程
 * @param {流程id} id
 */
export function getProjectProcessLatestApproved(id) {
  return request({
    url: '/project/process/latest/approved',
    method: 'post',
    data: {
      projectId: id
    }
  })
}

/**
 * 根据主键ID查流程
 * @param {流程id} id
 */
export function getProjectProcessSelectById(id) {
  return request({
    url: '/project/process/select/byId',
    method: 'post',
    data: {
      id: id
    }
  })
}

/**
 * 项目审批历史记录
 * @param {流程id} id
 */
export function getProjectApprovalHistory(id) {
  return request({
    url: '/project/process/approval/history',
    method: 'post',
    data: {
      projectId: id
    }
  })
}

/**
 * 审批公司流程
 * @param  data {
 * processId	流程ID
 * companyId	公司ID
 * status	审批状态 0-通过 1-拒绝
 * reason	审批意见
 *               }
 */
export function companyFlowFlowApproval(data) {
  return request({
    url: '/companyFlow/flow/approval',
    method: 'post',
    data: {
      ...data
    }
  })
}

/**
 * 审批项目流程
 * @param  data {
 * projectId    项目ID
 * processId	流程ID
 * companyId	公司ID
 * status	审批状态 0-通过 1-拒绝
 * reason	审批意见
 *               }
 */
export function projectFlowFlowApproval(data) {
  return request({
    url: '/projectFlow/flow/approval',
    method: 'post',
    data: {
      ...data
    }
  })
}

